import React, { useEffect, useState } from 'react'
import Styles from './styles.module.sass'

const Notifications = (props) => {
    const {
        type = 'warning',
        message,
        ctoa
    } = props

    const [ active, setActive ] = useState(false)

    useEffect( ()=>{
        if(message){
            setActive(true)
        }
    },[] )

    const handleClose = () => {
        setActive(false)
    }

    return(
        active
            ?
                <div className={`${Styles?.contNotificactions} ${Styles?.[type]}`}>
                    <span onClick={handleClose} className={Styles?.closeModal}>X</span>
                    <p>{  message }</p>
                    {ctoa &&
                        <div className={Styles?.contCtao}>
                            <span>{ctoa}</span>
                        </div>
                    }
                </div>
            : null
    )
}

export default Notifications